const findDialogTitle = (element) => {
	const dialog =
		element?.closest?.('.ui-dialog') ||
		element?.querySelector?.('.ddc-mobile-slidein');
	const dialogTitleEl =
		dialog?.querySelector?.('.ui-dialog-title') ||
		dialog?.querySelector?.('.ddc-heading-2') ||
		dialog?.querySelector?.('.ddc-mobile-slidein-content-inner h3');
	return dialogTitleEl?.textContent.trim();
};

export default findDialogTitle;
